module.exports = __webpack_public_path__ + "static/media/caret-down.44f8289c.svg";